(function () {
  var page = document.querySelector('[data-poc-to-win]');
  if (!page) return;

  var canvas = document.getElementById('ptw-bubble-canvas');
  var context = canvas ? canvas.getContext('2d') : null;
  var bubbles = [];
  var canvasWidth = 0;
  var canvasHeight = 0;

  function drawBubble(ctx, x, y, r, alpha) {
    var rim = ctx.createRadialGradient(x, y, r * 0.82, x, y, r);
    rim.addColorStop(0, 'rgba(61,255,122,0)');
    rim.addColorStop(0.55, 'rgba(160,210,40,' + alpha * 0.18 + ')');
    rim.addColorStop(1, 'rgba(130,195,30,' + alpha * 0.55 + ')');
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fillStyle = rim;
    ctx.fill();

    var body = ctx.createRadialGradient(x + r * 0.15, y - r * 0.15, r * 0.02, x, y, r * 0.88);
    body.addColorStop(0, 'rgba(190,240,110,' + alpha * 0.06 + ')');
    body.addColorStop(0.5, 'rgba(50,110,15,' + alpha * 0.03 + ')');
    body.addColorStop(1, 'rgba(0,0,0,' + alpha * 0.2 + ')');
    ctx.beginPath();
    ctx.arc(x, y, r * 0.9, 0, Math.PI * 2);
    ctx.fillStyle = body;
    ctx.fill();

    var highlight = ctx.createRadialGradient(x - r * 0.3, y - r * 0.32, 0, x - r * 0.22, y - r * 0.25, r * 0.36);
    highlight.addColorStop(0, 'rgba(255,255,255,' + alpha * 0.9 + ')');
    highlight.addColorStop(0.4, 'rgba(255,255,255,' + alpha * 0.2 + ')');
    highlight.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fillStyle = highlight;
    ctx.fill();

    var highlightSecond = ctx.createRadialGradient(x + r * 0.36, y + r * 0.3, 0, x + r * 0.36, y + r * 0.3, r * 0.13);
    highlightSecond.addColorStop(0, 'rgba(210,255,130,' + alpha * 0.55 + ')');
    highlightSecond.addColorStop(1, 'rgba(210,255,130,0)');
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fillStyle = highlightSecond;
    ctx.fill();

    for (var dotIndex = 0; dotIndex < 3; dotIndex++) {
      var microX = x + (Math.random() - 0.5) * r * 0.65;
      var microY = y + (Math.random() - 0.5) * r * 0.65;
      var microRadius = 0.8 + Math.random() * (r * 0.055);
      ctx.beginPath();
      ctx.arc(microX, microY, microRadius, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(190,255,110,' + alpha * 0.45 + ')';
      ctx.fill();
    }

    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(110,185,35,' + alpha * 0.4 + ')';
    ctx.lineWidth = 0.9;
    ctx.stroke();
  }

  function resizeCanvas() {
    if (!canvas || !context) return;

    var rect = canvas.getBoundingClientRect();
    var displayWidth = Math.max(1, Math.round(rect.width));
    var displayHeight = Math.max(1, Math.round(rect.height));
    var dpr = window.devicePixelRatio || 1;

    canvasWidth = displayWidth;
    canvasHeight = displayHeight;
    canvas.width = Math.round(displayWidth * dpr);
    canvas.height = Math.round(displayHeight * dpr);
    context.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function seedBubbles() {
    var width = canvasWidth || window.innerWidth;
    var height = canvasHeight || window.innerHeight;
    var isMobile = width <= 640;
    var isBelowDesktop = width <= 1200;
    var bubbleCount = isMobile ? 20 : isBelowDesktop ? 18 : 28;
    var minRadius = isMobile ? 3 : isBelowDesktop ? 5 : 6;
    var maxRadius = isMobile ? 40 : isBelowDesktop ? 68 : 90;
    bubbles = [];
    for (var i = 0; i < bubbleCount; i++) {
      var radius = minRadius + Math.random() * maxRadius;
      bubbles.push({
        x: Math.random() * width,
        y: Math.random() * height,
        r: radius,
        vx: (Math.random() - 0.5) * 0.3,
        vy: -(0.07 + Math.random() * 0.28),
        alpha: 0.55 + Math.random() * 0.45
      });
    }
  }

  function animateBubbles() {
    if (!canvas || !context) return;
    context.clearRect(0, 0, canvasWidth, canvasHeight);

    bubbles.forEach(function (bubble) {
      bubble.x += bubble.vx;
      bubble.y += bubble.vy;

      if (bubble.y + bubble.r < 0) {
        bubble.y = canvasHeight + bubble.r;
        bubble.x = Math.random() * canvasWidth;
      }

      if (bubble.x < -bubble.r) {
        bubble.x = canvasWidth + bubble.r;
      }

      if (bubble.x > canvasWidth + bubble.r) {
        bubble.x = -bubble.r;
      }

      drawBubble(context, bubble.x, bubble.y, bubble.r, bubble.alpha);
    });

    requestAnimationFrame(animateBubbles);
  }

  function setOverlayOpenState(id, isOpen) {
    var overlay = document.getElementById(id);
    if (!overlay) return;
    overlay.classList.toggle('is-open', isOpen);
  }

  function closeAllOverlays() {
    setOverlayOpenState('ptw-pdf-modal', false);
  }

  function bindModalTriggers() {
    page.querySelectorAll('[data-ptw-open-modal]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-ptw-open-modal');
        if (target) {
          setOverlayOpenState(target, true);
        }
      });
    });

    page.querySelectorAll('[data-ptw-close-modal]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-ptw-close-modal');
        if (target) {
          setOverlayOpenState(target, false);
        }
      });
    });

    page.querySelectorAll('.poc-to-win__overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
          overlay.classList.remove('is-open');
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllOverlays();
      }
    });
  }

  function triggerPdfDownload(pdfUrl, filename) {
    if (!pdfUrl) return;

    fetch(pdfUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('PDF download failed');
        return response.blob();
      })
      .then(function (blob) {
        var blobUrl = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename || 'download.pdf';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      })
      .catch(function () {
        var link = document.createElement('a');
        link.href = pdfUrl;
        link.download = filename || 'download.pdf';
        link.target = '_blank';
        link.rel = 'noopener';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }

  function attachPdfFormBehavior() {
    var pdfForm = document.getElementById('ptw-pdf-form');

    if (pdfForm) {
      pdfForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var nameInput = document.getElementById('ptw-pdf-name');
        var emailInput = document.getElementById('ptw-pdf-email');
        var success = document.getElementById('ptw-pdf-success');

        if (!nameInput || !emailInput || !success) return;
        if (!nameInput.value.trim() || !emailInput.value.trim()) return;
        if (!pdfForm.checkValidity()) {
          pdfForm.reportValidity();
          return;
        }

        var pdfUrl = pdfForm.getAttribute('data-pdf-url');
        var pdfFilename = pdfForm.getAttribute('data-pdf-filename') || 'Prove-It-In-Three-Weeks-Allure-Shopify.pdf';

        triggerPdfDownload(pdfUrl, pdfFilename);

        pdfForm.style.display = 'none';
        success.style.display = 'block';
        success.innerHTML =
          '✓ Thanks, ' +
          nameInput.value.trim() +
          '.<br>Your download is starting.<br><span class="poc-to-win__success-email">' +
          emailInput.value.trim() +
          '</span>';
      });
    }
  }

  resizeCanvas();
  seedBubbles();
  animateBubbles();
  window.addEventListener('resize', function () {
    resizeCanvas();
    seedBubbles();
  });

  bindModalTriggers();
  attachPdfFormBehavior();
})();
